import type { ReactNode } from 'react';

// 受付端末の確認ダイアログ。押し間違えにくいよう、決定ボタンを大きく、やめるボタンを離して置く。
export default function ConfirmDialog({
  title,
  children,
  confirmLabel,
  tone = 'ok',
  busy = false,
  onConfirm,
  onCancel,
}: {
  title: string;
  children?: ReactNode;
  confirmLabel: string;
  tone?: 'ok' | 'danger' | 'neutral';
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const confirmClass =
    tone === 'danger'
      ? 'bg-[#b3261e] shadow-[0_4px_0_#7a1a15]'
      : tone === 'neutral'
        ? 'bg-[#4a4a50] shadow-[0_4px_0_#2a2a2e]'
        : 'bg-[#127a3e] shadow-[0_4px_0_#0b5129]';
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 p-4" role="dialog" aria-modal="true">
      <div className="flex w-full max-w-[640px] flex-col gap-4 rounded-2xl bg-white p-6">
        <div className="text-[26px] font-extrabold text-[#1d1d1f]">{title}</div>
        {children}
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="h-[80px] w-[110px] shrink-0 whitespace-nowrap rounded-2xl border-[3px] border-[#d9d9de] bg-white text-[22px] font-extrabold text-[#3a3a40] sm:w-[180px] sm:text-[24px]"
          >
            やめる
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onConfirm}
            className={`h-[80px] flex-1 whitespace-nowrap rounded-2xl text-[24px] font-extrabold text-white disabled:opacity-60 sm:text-[28px] ${confirmClass}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
